import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/geometryReference';

export default function GeometryReference() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Quick-lookup formulas and rules for Geometry and Trigonometry — area and volume, angle relationships, right triangles, trig ratios, and circles."
      parts={parts}
    />
  );
}
